import React from 'react'

const Loader = ({loading}) => (<span>{loading ? ' loading... ' : ''}</span>)

export default Loader



// WEBPACK FOOTER //
// ./src/components/loader/loader.js